import React from 'react';

import { useFeatureFlag } from '~/src/common/services/FeatureFlag';
import { useNiceModal } from '~/src/common/services/ModalsManager/utils';
import Tracker from '~/src/common/services/Tracker/Tracker';
import { ProductDetailed } from '~/src/common/typings/product';
import { getPriceGranularity, getPricePerWeight } from '~/src/common/utils/prices';
import { GetDetailBySlug200BreadcrumbsItem } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import * as S from './layout';

interface Props {
  className?: string;
  product: ProductDetailed;
  categoriesBreadcrumbs: Partial<GetDetailBySlug200BreadcrumbsItem>[];
}

export const ProductPrimaryInformation = (props: Props) => {
  const showRating = useFeatureFlag('widgets-trustpilot') && props.product.rating != null;

  const granularity = getPriceGranularity(props.product.itemDefinition, {
    displayWeight: true,
    packSize: props.product.packSize,
  });

  const pricePerWeight = props.product.weightPrice
    ? getPricePerWeight(props.product.weightPrice)
    : null;

  const { show } = useNiceModal('product-ratings-modal');
  const openRatingsModal = () => {
    const isHomeProduct = props.categoriesBreadcrumbs.length < 2;
    const subcategory = props.categoriesBreadcrumbs[isHomeProduct ? 0 : 1].name;
    const category = isHomeProduct ? 'Accueil' : props.categoriesBreadcrumbs[0].name;

    void show({ id: props.product.sku });

    Tracker.sendEvent('view all reviews', {
      'product id': props.product.id,
      'product name': props.product.name,
      'product category': category ?? '',
      'product subcategory': subcategory,
      'product rating': props.product.rating?.average,
      'nb of ratings': props.product.rating?.nbRatings,
      'SKU': props.product.sku,
    });
  };

  return (
    <S.Root className={props.className}>
      <S.ProductName>{props.product.name}</S.ProductName>

      {showRating ? (
        <S.Rating showLabel onClick={openRatingsModal} rating={props.product.rating} />
      ) : null}

      <S.Granularity>
        <S.GranularityLabel>{granularity}</S.GranularityLabel>
        {pricePerWeight != null ? (
          <>
            <S.GranularitySeparator />
            <S.PricePerWeight>{pricePerWeight}</S.PricePerWeight>
          </>
        ) : null}
      </S.Granularity>
    </S.Root>
  );
};
